import React from "react";

interface CalculatorButtonProps {
  className?: string;
  visible?: boolean;
  onClick?: () => void;
}

export const CalculatorButton = ({
  className = "",
  visible = false,
  onClick,
}: CalculatorButtonProps) => {
  if (!visible) return null;

  return (
    <button type="button" onClick={onClick} className={className}>
      <ul>
        <li className="pluse">+</li>
        <li className="minuse">-</li>
        <li className="multiply">*</li>
        <li className="exactly">=</li>
      </ul>
    </button>
  );
};
